import { Avatar, Dropdown, Typography } from '@zeptonow/zui';
import { AppStore, UserStore } from '../store';
import { generateImage } from '../utilities/utils';

import { AuthService } from '../services';

const LogoutComponent = () => {
  const setIsLoggedIn = UserStore((state) => state.setIsLoggedIn);
  const setEntityCode = UserStore((state) => state.setEntityCode);
  const setEntityCodesList = UserStore((state) => state.setEntityCodesList);

  const handleLogout = async () => {
    await AuthService.logout();
    setEntityCode(null);
    setEntityCodesList(null);
    setIsLoggedIn(false);
  };

  const handleShowTermsAndConditions = () => {
    window.open('/assets/Tnc.pdf', '_blank');
  };

  const isFormDirty = AppStore((state) => state.isFormDirty);
  const setShowUnsavedWorkConfirmationModal = AppStore(
    (state) => state.setShowUnsavedWorkConfirmationModal
  );

  const onAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isFormDirty) {
      event.stopPropagation();
      setShowUnsavedWorkConfirmationModal(true);
    }
  };

  const TermsAndConditionsItems = (
    <div className="w-full space-x-2 flex justify-center items-center py-1">
      {generateImage({
        name: 'report-gray',
        alt: 'tnc icon',
        className: 'w-4 h-4',
      })}
      <Typography className="!text-gray-700 !font-medium !text-base !flex !items-center !justify-center">
        Terms And Conditions
      </Typography>
    </div>
  );

  const UserLogoutItem = (
    <div className="w-full space-x-2 flex justify-center items-center py-1">
      {generateImage({
        name: 'logout',
        alt: 'logout icon',
        className: 'h-4 w-4',
      })}
      <Typography className="!text-gray-700 !font-medium !text-base !flex !items-center !justify-center">
        Logout
      </Typography>
    </div>
  );

  const DividerComponent = (
    <div className="w-full h-[0.03rem] bg-gradient-to-r from-white via-gray-400 to-white" />
  );

  return (
    <Dropdown
      className="!rounded-xl !max-w-xs !max-h-xs !m-0"
      dividerComponent={DividerComponent}
      items={[
        {
          id: 'tnc',
          element: TermsAndConditionsItems,
          action: handleShowTermsAndConditions,
          ripple: true,
        },
        {
          id: 'logoutItem',
          element: UserLogoutItem,
          action: handleLogout,
          ripple: true,
        },
      ]}
    >
      <div onClickCapture={onAvatarClick}>
        <Avatar>
          {generateImage({
            name: 'gray-profile',
            alt: 'profile icon',
            className: 'h-5 w-5',
          })}
        </Avatar>
      </div>
    </Dropdown>
  );
};

export default LogoutComponent;
